import { Injectable } from '@angular/core';

import { Effect, Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';

import { RequestService,FileService } from '../../data';
import { NotificationService } from '../../../shared/services/notification.service';

import * as fromActions from '../actions/request.actions'
import * as fromRoot from '@app/core/store/actions/router.actions';

@Injectable()
export class RequestEffects {
  constructor(private actions$: Actions,
    private requestService: RequestService,
    private fileService: FileService,
    private notificationService: NotificationService) { }


  @Effect()
  loadRequestHistory$ = this.actions$.ofType(fromActions.RequestActionTypes.LoadRequestHistory).pipe(
      map((action: fromActions.LoadRequestHistory) => action.payload),
    switchMap(requestId => {
      return this.requestService.getRequestHistory(requestId).pipe(
        map(history => new fromActions.LoadRequestHistorySuccess(history)),
        catchError(error => of(new fromActions.LoadRequestHistoryFail(error)))
      )
    })
  );

  @Effect({ dispatch: false })
  loadRequestHistoryFail$ = this.actions$.ofType(fromActions.RequestActionTypes.LoadRequestHistoryFail).pipe(
    map((action: fromActions.LoadRequestHistoryFail) => action.payload),
    map(error => {
      this.notificationService.error(error);
    })
  );

  @Effect()
  loadRequestFiles$ = this.actions$.ofType(fromActions.RequestActionTypes.LoadRequestFiles).pipe(
    map((action: fromActions.LoadRequestFiles) => action.payload),
    switchMap(requestId => {
      return this.requestService.getRequestFiles(requestId).pipe(
        map(Files => new fromActions.LoadRequestFilesSuccess(Files)),
        catchError(error => of(new fromActions.LoadRequestFilesFail(error)))
      )
    })
  );

  @Effect({ dispatch: false })
  loadRequestFilesFail$ = this.actions$.ofType(fromActions.RequestActionTypes.LoadRequestFilesFail).pipe(
    map((action: fromActions.LoadRequestFilesFail) => action.payload),
    map(error => {
      this.notificationService.error(error);
    })
  );

  @Effect()
  loadRequestCharge$ = this.actions$.ofType(fromActions.RequestActionTypes.LoadRequestCharge).pipe(
    map((action: fromActions.LoadRequestCharge) => action.payload),
    switchMap(requestId => {
      return this.requestService.getRequestCharge(requestId).pipe(
        map(charge => new fromActions.LoadRequestChargeSuccess(charge)),
        catchError(error => of(new fromActions.LoadRequestChargeFail(error)))
      )
    })
  );

  @Effect({ dispatch: false })
  loadRequestChargeFail$ = this.actions$.ofType(fromActions.RequestActionTypes.LoadRequestChargeFail).pipe(
    map((action: fromActions.LoadRequestChargeFail) => action.payload),
    map(error => {
      this.notificationService.error(error);
    })
  );

  @Effect({ dispatch: false })
  downloadFileByPath$ = this.actions$.ofType(fromActions.RequestActionTypes.DownloadFileByPath).pipe(
      map((action: fromActions.DownloadFileByPath) => action.payload),
      map(path => this.fileService.downloadFileByPath(path))
  );


  @Effect()
  addRequestFeedback$ = this.actions$.ofType(fromActions.RequestActionTypes.AddRequestFeedback).pipe(
    map((action: fromActions.AddRequestFeedback) => action.payload),
      switchMap(model => {
        return this.requestService.addFeedback(model).pipe(
          map(request => {
            this.notificationService.success(`Your feedback has been added successfully`);
            return new fromRoot.Go({
              path: ['/dashboard'],
            });
          }),
          catchError(error => of(new fromActions.AddRequestFeedbackFail(error)))
      )
    })
  );

  @Effect()
  LoadRequestFeedbacks$ = this.actions$.ofType(fromActions.RequestActionTypes.LoadRequestFeedbacks).pipe(
      map((action: fromActions.LoadRequestFeedbacks) => action.payload),
    switchMap(pagination => {
      return this.requestService.getRequestFeedbacks(pagination).pipe(
        map(data => new fromActions.LoadRequestFeedbacksSuccess(data)),
        catchError(error => of(new fromActions.LoadRequestFeedbacksFail(error)))
      )
    })
  );

  @Effect({ dispatch: false })
  LoadRequestFeedbacksFail$ = this.actions$.ofType(fromActions.RequestActionTypes.LoadRequestFeedbacksFail).pipe(
      map((action: fromActions.LoadRequestFeedbacksFail) => action.payload),
    map(error => {
      this.notificationService.error(error);
    })
  );

}



// WEBPACK FOOTER //
// ./src/app/core/store/effects/request.effects.ts